<template>
  <v-card flat>
    <v-toolbar dense flat tile color="white">
      <v-btn depressed small color="primary" @click="adicionar">Adicionar Chave Pix</v-btn>
    </v-toolbar>

    <v-divider></v-divider>

    <v-card-text class="pa-0">
      <v-data-table
        mobile-breakpoint="0"
        hide-default-footer
        disable-pagination
        disable-sort
        fixed-header
        no-data-text="Para adicionar uma chave pix, clique no botão acima"
        height="383px"
        :headers="headers"
        :items="$store.state.fornecedores.fornecedor.chavespix"
      >

        <template #item.tipo="{ item }">
          {{ tipos_chave_pix[item.tipo] }}
        </template>

        <template #item.opcoes="{ item }">
          <v-btn icon @click.stop="compartilhar(item)">
            <v-icon>mdi-share-variant</v-icon>
          </v-btn>
          <v-btn icon @click.stop="editar(item)">
            <v-icon>mdi-pencil</v-icon>
          </v-btn>
          <v-btn icon @click.stop="excluir(item)">
            <v-icon>mdi-delete</v-icon>
          </v-btn>
        </template>

      </v-data-table>
    </v-card-text>
    <ModalChavePix ref="modalchavepix"></ModalChavePix>

    <z-dialogo-sim-nao 
      ref="dialogoExcluir" 
      titulo="Remover Chave Pix" 
      botaoSim="Remover" 
      botaoNao="Cancelar" 
      :loading="excluindo"
    >
      A chave pix será removida. Deseja remover?
    </z-dialogo-sim-nao>

  </v-card>
</template>

<script setup>
import { onMounted, ref, getCurrentInstance, inject } from "vue";
import ModalChavePix from "./modais/ModalChavePix.vue";

const { proxy } = getCurrentInstance();
const $store = proxy.$store;
const $globals = proxy.$globals;
const $notificacao = inject('notificacao');

const headers = [
  { text: 'Chave', value: 'chave' },
  { text: 'Tipo', value: 'tipo' },
  { text: 'Titular', value: 'titular' },
  { text: 'Opções', value: 'opcoes', width: '200px', align: 'center' },
]

const tipos_chave_pix = $globals.TIPOS_CHAVE_PIX;

const modalchavepix = ref(null);
const excluindo = ref(false);
const dialogoExcluir = ref(false);

function adicionar() {
  modalchavepix.value.abrir();
}

async function editar(chavepix) {
  await $store.dispatch('fornecedores/exibirChavePix', chavepix.id);
  modalchavepix.value.abrir();
}

async function excluir(chavepix) {

  const resposta = await dialogoExcluir.value.abrir();

  if (resposta == false) {
    return;
  }

  excluindo.value = true;

  try {
    await $store.dispatch('fornecedores/excluirChavePix', chavepix.id);

    $notificacao.notificar("ChavePix excluída com sucesso");
  } catch (error) {
    $notificacao.error("Não foi possível excluir a ChavePix", error);
    throw error;
  } finally {
    dialogoExcluir.value.fechar()
    excluindo.value = false;
  }
}

</script>

<style lang="scss" scoped>

</style>